const Accordion              = require('./accordion/accordion');
const AutoRotator      		 = require('./auto-rotator/script');
const ColorSelector          = require('./color-selector/script');
const ImageSwappable         = require('./image-swappable/script');
const RatingStars            = require('./rating-stars/script');
const SimpleSlider           = require('./simple-slider/script');
const SimpleToggle           = require('./toggle/toggle');
const SizeSelector           = require('./size-selector/script');
const Tabs                   = require('./tabs/tabs');
const WigglePhoto            = require('./wiggle-photo/script');

require('./alerts/alerts');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-accordion]', function () {
		new Accordion(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-auto-rotator]', function () {
		new AutoRotator(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-color-selector]', function () {
		new ColorSelector(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-image-swappable]', function () {
		new ImageSwappable(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-rating-stars]', function () {
		new RatingStars(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-simple-slider]', function () {
		new SimpleSlider(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-toggle]', function () {
		new SimpleToggle(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-size-selector]', function () {
		new SizeSelector(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-wiggle-photo]', function () {
		new WigglePhoto(this);
	});

	// mini-modules that do not necessitate classes (yet)

	window.SETTINGS.domScan.addElement($scanContainer, '[data-heart-toggle]', function () {

		let $this = $(this);

		$this.on('click', () => {

			if ( $this.hasClass('is-active') ) {
				$this.removeClass('is-active');
			} else {
				$this.addClass('is-active');
				$this.triggerHandler('activate');
			}
		});
	});

	// synched height groups

	window.SETTINGS.domScan.addElement($scanContainer, '[data-sync-height-group]', function(){

		let $this		= $(this);
		let $cols		= $this.find('[data-sync-height]');
		let minWidth	= $this.data('sh-min-width') || null;
		let groupIds 	= [];

		let checkHeightDebouncer = _.throttle(checkHeightSync, 500);

		window.vent.on('windowResize', checkHeightDebouncer);
		window.vent.on('fontsActive', checkHeightDebouncer);

		function checkHeightSync(){

			groupIds = [''];

			$cols.each((index, value) => {
				let $col = $(value);
				let id = $col.data('sync-height');
				if(id && groupIds.indexOf(id) === -1){
					groupIds.push(id);
				}
			});

			for(let i=0; i<groupIds.length; i++){

				let maxHeight = 0;
				let $filteredCols = groupIds[i] ? $cols.filter('[data-sync-height=\"' + groupIds[i] + '\"]') : $cols.filter('[data-sync-height]');
				let $masterCol	= $filteredCols.find('[data-sh-master]');

				if ( !minWidth || window.innerWidth > minWidth ){

					$filteredCols.each((index, value) => {

						let $col = $(value);
						$col.css('min-height', '');

						let colHeight = $col.outerHeight();

						if ( $masterCol.length ){
							maxHeight = $masterCol.outerHeight();
						} else if ( colHeight > maxHeight ){
							maxHeight = colHeight;
						}
					});
				} else {
					maxHeight = '';
				}

				$filteredCols.each((index, value) => {
					$(value).css('min-height', maxHeight);
				});
			}
		}

		window.requestAnimationFrame(() => {
			checkHeightSync();
		});
	});

	// swap groups (like tabs)

	window.SETTINGS.domScan.addElement($scanContainer, '[data-swap-group]', function(){

		let $this			= $(this);
		let $buttons		= $this.find('[data-sg-button]'); // param: include id(s), comma separated
		let $targets		= $this.find('[data-sg-target]'); // param: include matching id
		let swapClass		= $this.attr('data-sg-class') || 'is-active';

		$buttons.on('click', (e) => {
			let $target  = $(e.currentTarget);
			swapClassByButton($target);
		});

		if(!$buttons.hasClass(swapClass)){
			swapClassByButton($buttons.eq(0));
		}

		function swapClassByButton($button){

			let toggleId 	= $button.attr('data-sg-button');
			let idArray 	= toggleId.split(',');
			let $toggleOff 	= $buttons.add($targets);
			let $toggleOn	= null;

			for(let i=0; i<idArray.length; i++){

				let id = idArray[i];
				let $target = $this.find('[data-sg-target=\"' + id + '\"]').add($button);

				if($target.length){
					if($toggleOn){ $toggleOn.add($target); }
					else { $toggleOn = $target; }
				}
			}

			$toggleOff.removeClass(swapClass);
			$toggleOn.addClass(swapClass);

			// fire event when active

			$toggleOn.each((index, value) => {
				$(value).triggerHandler('activate');
			});
		}
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-sticky-group]', function(){

		let $this = $(this);
		let $cols = $this.find('[data-sg-col]');

		$cols.stick_in_parent({
			parent: $this
		});
	});

});
